import { render } from "./PlatOrderStatistic.vue?vue&type=template&id=34812604"
import script from "./PlatOrderStatistic.vue?vue&type=script&lang=js"
export * from "./PlatOrderStatistic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__